import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import { DEFAULT_ALLOWED_DEVICE_CODE_LENGTH } from "@jti/fe-common";
export const defaultAemModel = {
    ageVerificationMethodImages: {
        international_passport: "",
        passport: "",
        driving_license: "",
    },
    deviceRegistration: {
        isDeviceRegistrationMandatory: false,
        isDeviceRegistrationByLeafletEnabled: false,
        isScanDeviceQrEnabled: false,
        deviceCodeLength: DEFAULT_ALLOWED_DEVICE_CODE_LENGTH,
    },
    genderInformation: {
        isGenderEnabled: false,
    },
    registrationSuccessPage: {
        hidePloomClubBanner: false,
        disclaimer: "",
        learnMoreLinkText: "",
        learnMoreLinkUrl: "",
        successBannerMessage: "",
    },
    loyaltyCardSuccessPage: { isLoyaltyCardSuccessPageEnabled: false, isPloomBenefitsBannerHidden: false },
    offlineRegistration: {
        isAvEnabled: false,
        isDeviceRegistrationEnabled: false,
    },
    phoneValidationOtp: {
        successValidationViaSmsMessage: "",
        failedValidationViaSmsMessage: "",
        isOtpNumeric: false,
    },
    emailValidation: {
        isOtpNumeric: false,
    },
    commonLoginSettings: {
        socialLoginSeparatorText: "",
        loginFormMode: "email",
        loginFormModeDefaultTab: "email",
        isKeepMeLoggedInEnabled: false,
    },
};
const AemModelContext = React.createContext(defaultAemModel);
export const AemModelProvider = ({ children, model }) => {
    return _jsx(AemModelContext.Provider, { value: model, children: children });
};
export const useAemModel = () => {
    return useContext(AemModelContext);
};
